import React, { useEffect, useMemo, useState } from 'react';
import { StatusTip } from 'tea-component';
import './index.scss';
import { DefaultImg } from '@op/constants/defaultImg';
import { dealwithBiLiBiLiImage } from '@op/utils/cdnUrl';
import AIGeneratedTag from '@op/components/AIGeneratedTag';

/**
 * 图片渲染组件
 * @param  coverImage     实际图片
 * @param  className      样式名称
 * @param  onClick        点击事件
 * @param  defaultImage   默认图片
 * @returns
 */
export default function RenderImg({
  coverImage,
  className = '',
  onClick,
  setLoading = (loading: boolean) => { },
  defaultImage = DefaultImg.KOL,
  style,
  mode = 'backgroundImage',
  box = false,
  aigc = false,
}: {
  coverImage: string;
  className?: string;
  onClick?: (e) => void;
  setLoading?: (loading: boolean) => void;
  defaultImage?: string;
  style?: React.CSSProperties;
  mode?: 'backgroundImage' | 'image';
  box?: boolean;
  aigc?: boolean;
}) {
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);
  const [resolvedSrc, setResolvedSrc] = useState('');
  function changeLoading(value: boolean) {
    setLoading(value);
    setImageLoading(value);
  }
  const status = imageLoading ? 'loading' : imageError ? 'error' : '';

  function retry() {
    loadImg();
  }

  function loadImg() {
    if (!coverImage) {
      changeLoading(false);
      setImageError(true);
      return;
    }

    const curImage = new Image();
    const curImageSrc = dealwithBiLiBiLiImage(coverImage);
    curImage.src = curImageSrc;
    curImage.onload = () => {
      setResolvedSrc(curImageSrc);
      changeLoading?.(false);
      setImageError?.(false);
    };
    curImage.onerror = () => {
      changeLoading?.(false);
      setImageError?.(true);
    };
  }

  useEffect(() => {
    loadImg();
  }, [coverImage]);

  const displaySrc = useMemo(
    () => (imageLoading || imageError ? defaultImage : resolvedSrc),
    [imageLoading, imageError, defaultImage, resolvedSrc],
  );

  const renderImg = () => {
    if (mode === 'backgroundImage') {
      if (aigc) {
        return (
          <div className="dbo-render-img-wrapper" >
            <div
              className={`${className} ${imageLoading || imageError ? 'default-img' : ''}`}
              onClick={(e) => {
                if (onClick) {
                  e.stopPropagation();
                  onClick?.(e);
                }
              }}
              style={{
                backgroundImage: `url("${displaySrc}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                cursor: onClick ? 'pointer' : 'default',
                ...style,
              }}
            ></div>
            {aigc && (
              <div className="dbo-render-img-ai-tag">
                <AIGeneratedTag />
              </div>
            )}
          </div>
        );
      }
      return (
        <div
          className={`${className} ${imageLoading || imageError ? 'default-img' : ''}`}
          onClick={(e) => {
            if (onClick) {
              e.stopPropagation();
              onClick?.(e);
            }
          }}
          style={{
            backgroundImage: `url("${displaySrc}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            cursor: onClick ? 'pointer' : 'default',
            ...style,
          }}
        ></div>
      );
    }
    if (aigc === true && mode === 'image') {
      return (
        <div className="dbo-render-img-wrapper">
          <img
            className={`dbo-no-invert ${className} ${imageLoading || imageError ? 'default-img' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              onClick?.(e);
            }}
            src={displaySrc}
            style={{
              cursor: onClick ? 'pointer' : 'default',
              ...style,
            }}
          />
          {aigc && (
            <div className="dbo-render-img-ai-tag">
              <AIGeneratedTag />
            </div>
          )}
        </div>
      );
    }
    return (
      <img
        className={`dbo-no-invert ${className} ${imageLoading || imageError ? 'default-img' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
        src={displaySrc}
        style={{
          cursor: onClick ? 'pointer' : 'default',
          ...style,
        }}
      />
    );
  };

  if (box) {
    return status ? (
      <div
        style={{
          height: 200,
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <StatusTip
          className="dbo-render-img-status-tip"
          hideIcon={!imageLoading}
          status={status}
          onRetry={() => {
            changeLoading(true);
            setImageError(false);

            retry();
          }}
          errorText="Data loading failed, "
          retryText="click to reload"
          loadingText=""
        />
      </div>
    ) : (
      renderImg()
    );
  }
  return <>{renderImg()}</>;
}
